<template>
  <v-container fluid fill-height class="login-page">
    <v-row align="center" justify="center">
      <v-col cols="11" sm="7" md="5" lg="4" xl="3">
        <v-card class="elevation-12" style="border-radius: 16px;">
          <div class="text-center pt-8">
            <v-img src="/MUIC_Logo_Eng_Center.png" max-width="270" class="mx-auto mb-2"></v-img>
            <div style="font-size: 24px !important; color: #5D2E86 !important;"
              class="text-h5 text-md-h4 mt-5 font-weight-bold mb-0">
              IC Portal Login
            </div>
            <div style="font-size: 16px !important;" class="text-body-2 grey--text text--darken-1 mb-0">
              Please select a login method
            </div>
          </div>
          <v-card-text class="text-center">
            <v-col cols="12" class="d-flex flex-column align-center">
              <v-btn color="#5D2E86" dark x-large block height="auto" class="mb-2 text-none py-2"
                style="border-radius: 8px;" @click="loginMsal" :loading="loadingMsal" :disabled="loadingMsal">
                <span style="color: white;font-size: 20px !important;" class="text-h6 font-weight-regular">
                  MUIC SSO (Preferred)
                  <br><small style="font-weight: 400; opacity: 0.85; font-size: 12px;">Login with your SKY+/MUIC Account
                    @muic.io</small>
                </span>
              </v-btn>
              <!--  
                <a
                  href="#"
                  @click.prevent="loginMuicSSO"
                  class="text-body-2"
                  style="align-self: flex-end; color: #757575; font-style: italic; text-decoration: underline;"
                >
                  Old MUIC SSO
                </a>
              -->
              <v-alert v-if="errorMessage" type="error" dense outlined class="mt-4" width="100%">
                {{ errorMessage }}
              </v-alert>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { msalInstance, MSAL_SCOPES } from "@/plugins/msal";

export default {
  data() {
    return {
      errorMessage: "",
      loadingMsal: false,
    };
  },

  async mounted() {
    // ✅ handle response (กัน edge case popup/redirect)
    try {
      const response = await msalInstance.handleRedirectPromise();
      if (response && response.account) {
        msalInstance.setActiveAccount(response.account);
        this.$router.push("/overview");
      }
    } catch (err) {
      console.error("Redirect handling error:", err);
    }

    // ✅ ลบเฉพาะ key ของ app
    localStorage.removeItem("login_error");

    const error = localStorage.getItem("login_error");
    if (error) {
      this.errorMessage = error;
    }

    // reset store
    this.$store.dispatch("setRoleUser", {
      username: "",
      role: [],
      permissions: "",
      server_status: "off",
      RolePdPCChair: false,
    });
  },

  methods: {
    async loginMsal() {
      if (this.loadingMsal) return;

      this.loadingMsal = true;
      this.errorMessage = "";

      // Ensure auth_type is set before we redirect away
      localStorage.setItem("auth_type", "msal");

      try {
        await msalInstance.loginRedirect({
          scopes: MSAL_SCOPES,
          prompt: "select_account",
        });
        // The page will redirect, so we don't need to do anything else here.
      } catch (error) {
        console.error("MSAL Login Failed", error);

        if (
          error.name === "BrowserAuthError" &&
          error.errorCode === "interaction_in_progress"
        ) {
          this.errorMessage =
            "Login interaction is already in progress.";
        } else {
          this.errorMessage = "MSAL Login Failed: " + error.message;
        }

        this.loadingMsal = false;
      }
    },

    loginMuicSSO() {
      this.errorMessage = "";

      if (this.$keycloak) {
        const loginUrl = this.$keycloak.createLoginUrl({
          redirectUri: window.location.origin + "/overview",
        });

        window.location.replace(loginUrl);
        localStorage.setItem("auth_type", "keycloak");
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  background: url('/bg_sso_ic.jpg') no-repeat center center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
</style>

<style>
.container {
  padding: 0 !important;
}
</style>